var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6462 7.74054H1.24039C1.02789 7.74054 0.849776 7.66864 0.706042 7.52482C0.562292 7.381 0.490417 7.2028 0.490417 6.99022C0.490417 6.77762 0.562292 6.59953 0.706042 6.45594C0.849776 6.31236 1.02789 6.24057 1.24039 6.24057H16.6462L12.3096 1.88862C12.1733 1.75177 12.102 1.5807 12.0958 1.37542C12.0896 1.17014 12.1609 0.992578 12.3096 0.842744C12.4459 0.705394 12.6194 0.636719 12.8301 0.636719C13.0408 0.636719 13.2154 0.705953 13.3538 0.84442L18.8673 6.35787C18.9609 6.45145 19.0269 6.55059 19.0653 6.65529C19.1038 6.75999 19.123 6.87218 19.123 6.99184C19.123 7.11149 19.1037 7.22517 19.0649 7.33287C19.0261 7.44055 18.9603 7.54054 18.8673 7.63284L13.3538 13.1463C13.217 13.2848 13.0459 13.354 12.8406 13.354C12.6353 13.354 12.4583 13.2848 12.3096 13.1463C12.1545 12.9976 12.0785 12.8194 12.0817 12.6117C12.0849 12.404 12.1609 12.2258 12.3096 12.0771L16.6462 7.74054Z",
    fill: "#FBFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4a37da58b8afb0a5241718850121a3bd.svg";
export { ForwardRef as ReactComponent };